export const brakeSF = 1.5;

export const brakeData = [     // Drum Brake
    {
        model: 'HN132',
        torque: 6.7,        // kg-m
        inertia: 0.025,     // wk2 of Drum kg-m2
        weight: 34.0,
    },
    {
        model: 'HN160',
        torque: 21.2,
        inertia: 0.075,
        weight: 57.0,
    },
    {
        model: 'HN180',
        torque: 30.0,
        inertia: 0.175,
        weight: 67.0,
    },
    {
        model: 'HN200',
        torque: 40.0,
        inertia: 0.175,
        weight: 72.0,
    },
    {
        model: 'HN225',
        torque: 53.0,
        inertia: 0.5,
        weight: 107.0,
    },
    {
        model: 'HN250',
        torque: 80.0,
        inertia: 0.875,
        weight: 122.0,
    },
    {
        model: 'HN280',
        torque: 132.0,
        inertia: 1.625,
        weight: 132.0,
    },
    {
        model: 'HN315',
        torque: 180.0,
        inertia: 2.875,
        weight: 192.0,
    },
    {
        model: 'HN355',
        torque: 335.0,
        inertia: 4.5,
        weight: 278.0,
    },
    {
        model: 'HN400',
        torque: 475.0,
        inertia: 8.0,
        weight: 378.0,
    },
    {
        model: 'HN527',
        torque: 660.0,
        inertia: 27.5,
        weight: 908.0,
    },
];


export const selectBrake = (value) => {
    if (isNaN(value)) return null;

    const selected = brakeData.find(obj => obj.torque >= Number(value));

    if (!selected) {
        return {
            model: 'HN527',
            torque: 660.0,
            inertia: 27.5,
            weight: 908.0,
        };
    }

    return selected;
}
